import { COUNTRY_EU_CODES } from '../../../consts/country.const'
import { QueryStringFilter } from '../../../models/query-string.model'
import {
  applyComparisonOperator,
  applyDateRangeFilter,
  parseFilters,
} from '../../../libs/filter.lib'
import {
  GoodsReturnField,
  GoodsReturnSearchParams,
} from '../models/goods-return-search.model'

export function parseGoodsReturnFilters(
  params: GoodsReturnSearchParams,
  filters: GoodsReturnSearchParams,
): GoodsReturnSearchParams {
  return parseFilters(params, filters, goodsReturnFilterParams)
}

export function goodsReturnFilterParams(
  params: GoodsReturnSearchParams,
  filter: QueryStringFilter<GoodsReturnField>,
): GoodsReturnSearchParams {
  const searchParams: Partial<GoodsReturnSearchParams> = {}
  const value = Array.isArray(filter.value)
    ? filter.value.length
      ? filter.value[0]
      : undefined
    : filter.value

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value as string | string[]
      }
      break
    case 'status':
      if (filter.value !== null) {
        searchParams['status'] = filter.value
      }
      break
    case 'warehouseId':
      if (filter.value !== null) {
        searchParams.warehouseId = filter.value as string | string[]
      }
      break
    case 'createdAt':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'createdAt',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'createdAt',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.returnNumber':
      if (filter.operator === 'between') {
        return params
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'header.returnNumber',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.channelId':
      if (filter.value !== null) {
        searchParams['header.channelId'] = filter.value as string | string[]
      } else {
        searchParams['header.channelId:ex'] = false
      }
      break
    case 'header.reasonId':
      if (filter.value !== null) {
        searchParams['header.reasonId'] = filter.value as string | string[]
      } else {
        searchParams['header.reasonId:ex'] = false
      }
      break
    case 'header.paymentId':
      if (filter.value !== null) {
        searchParams['header.paymentId'] = filter.value as string | string[]
      } else {
        searchParams['header.paymentId:ex'] = false
      }
      break
    case 'header.currency':
      if (filter.value !== null) {
        searchParams['header.currency'] = filter.value as string | string[]
      }
      break
    case 'header.date':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'header.date',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'header.date',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.arrivalDate':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'header.arrivalDate',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'header.arrivalDate',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.creditNotes':
      if (filter.operator === '=') {
        searchParams['header.creditNotes'] = filter.value as string
      }
      break
    case 'header.refundDate':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'header.refundDate',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'header.refundDate',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.refundNotes':
      if (filter.operator === '=') {
        searchParams['header.refundNotes'] = filter.value as string
      }
      break
    case 'header.shippingAddress.countryCode':
      if (filter.value === 'CEE') {
        searchParams['header.shippingAddress.countryCode'] = COUNTRY_EU_CODES
      } else if (filter.value !== null) {
        searchParams['header.shippingAddress.countryCode'] = filter.value as
          | string
          | string[]
      }
      break
    case 'referenceOrder.number':
      if (filter.operator === '=') {
        searchParams['referenceOrder.number'] = filter.value as number
      }
      break
    case 'referenceOrder.refDate':
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'referenceOrder.refDate',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'referenceOrder.refOrder':
      if (filter.operator === '=') {
        searchParams['referenceOrder.refOrder'] = filter.value as string
      }
      break
    case 'recoveryOrder.number':
      if (filter.operator === '=') {
        searchParams['recoveryOrder.number'] = filter.value as number
      }
      break
    case 'recoveryOrder.refDate':
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'recoveryOrder.refDate',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'recoveryOrder.refOrder':
      if (filter.operator === '=') {
        searchParams['recoveryOrder.refOrder'] = filter.value as string
      }
      break
    case 'tags':
      if (filter.value !== null) {
        searchParams['tags'] = filter.value as string | string[]
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
